
import React from "react";
import { NavLink } from "react-router-dom";
import { cn } from "@/lib/utils";
import { LucideIcon } from "lucide-react";

interface NavItemProps {
  item: {
    name: string;
    path: string;
    icon: LucideIcon;
  };
  isCollapsed: boolean;
  onClick?: () => void;
}

const SidebarNavItem: React.FC<NavItemProps> = ({ item, isCollapsed, onClick }) => {
  return (
    <li key={item.path}>
      <NavLink
        to={item.path}
        className={({ isActive }) => cn(
          "flex items-center gap-2 px-3 py-2.5 rounded-lg transition-all",
          isActive
            ? "bg-primary text-white"
            : "text-gray-700 dark:text-gray-300 hover:bg-primary/10 hover:text-primary"
        )}
        onClick={onClick}
      >
        <item.icon size={20} />
        {!isCollapsed && <span>{item.name}</span>}
      </NavLink>
    </li>
  );
};

export default SidebarNavItem;
